import { Emit, Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import { onErrorImageAvatar } from '@/util/common-util';
import { namespace } from 'vuex-class';
import { getHostName } from '../../../../../../util/ds-util';
import moment from 'moment';
import { formatDateAgo } from '@/../app/util/date-util';

const briefingStore = namespace('briefingStore');
const appStoreState = namespace('appStore');

@Component({
  methods: { getHostName, onErrorImageAvatar, formatDateAgo },
  components: {},
  computed: {
    moment() {
      return moment;
    },
  },
})
export default class ResourceFooterComponent extends Vue {
  @Prop(Object) readonly formModel: IResourceModel;
  @Prop(Boolean) readonly isHideOptions: boolean;
  @Prop(Boolean) readonly isHideAddReference: boolean;
  @Prop(Boolean) readonly isHideHidden: boolean;
  @Prop(Boolean) readonly isHideShared: boolean;
  @Prop(Boolean) readonly isHideGoover: boolean;

  @appStoreState.Mutation
  public setIsShowShareReport!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowShareTopic!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowBackdrop!: (payload: boolean) => void;

  @briefingStore.Mutation
  public setSelectedResource!: (payload: IResourceModel) => void;

  get userKey() {
    return this.$store.getters?.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id;
  }

  share() {
    this.setSelectedResource(this.formModel);
    this.setIsShowBackdrop(true);
    if (this.formModel.type === 'REPORT') {
      this.setIsShowShareReport(true);
    } else {
      this.setIsShowShareTopic(true);
    }
    setTimeout(() => {
      this.$root.$emit('shareReport', this.formModel.docId);
    }, 50);
  }

  @Emit('hide') hide() {
    this.handleClickDropDown();
  }

  @Emit('select-user-social') selectUserSocial() {}

  @Emit('toggle-resource') toggleResource() {}

  @Emit('add-to-reference') addToReference() {}

  @Emit('goover') goover() {}

  openLink() {
    window.open(this.formModel.url, '_blank');
  }

  @briefingStore.Getter
  getReferenceDocuments!: Array<any>;
  downloadStatus = false;

  handleClickDropDown() {
    const button = document.getElementById('dropDownDiscoveryButton' + this.formModel?.docId);

    if (button) {
      button.click();
    }
  }

  async downloadPodcast(url: string, title: string) {
    if (!url) return;

    this.downloadStatus = true;

    try {
      const fileResponse = await fetch(url);
      if (!fileResponse.ok) throw new Error('Failed to fetch file');
      const blob = await fileResponse.blob();

      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${title}.mp3`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
    } finally {
      this.downloadStatus = false;
    }
  }
}
